<template>
  <div class="tally-consumption-table">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Tjänst
            </th>
            <th class="text-right">
              Antal
            </th>
            <th class="text-right">
              Tidpunkt
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="isFetchingConsumptionPage || isLoading">
            <tr v-for="i in skeletonRows" :key="i">
              <td>
                <v-skeleton-loader
                  style=""
                  type="table-cell"
                  class=""
                ></v-skeleton-loader>
              </td>
              <td v-for="x in 2" :key="x" class="text-right">
                <v-skeleton-loader
                  style=""
                  type="table-cell"
                  class=""
                ></v-skeleton-loader>
              </td>
            </tr>
          </template>
          <template v-else-if="error">
            <tr>
              <td colspan="3" class="text-center">
                <v-alert dense text type="error" class="my-4">Förbrukningshistoriken kunde inte hämtas. Försök igen.</v-alert>
                <v-btn small text @click="getPage(currentPage)">Försök igen</v-btn>
              </td>
            </tr>
          </template>
          <template v-else-if="pageItems.length === 0">
            <tr class="table-row-no-consumption">
              <td colspan="3">
                <v-alert
                  dense
                  text
                  color="info"
                  class="my-4 mx-auto text-center"
                >
                  Det finns ingen debiterbar förbrukning
                </v-alert>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              v-for="(item, i) in pageItems"
              :key="i"
            >
              <td>{{ item.service_name }}</td>
              <td class="text-right">{{ item.consumption }}</td>
              <td class="text-right">{{ formatDateTime(item.consumed_at) }}</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <div v-show="totalPages > 1" class="text-center pt-4">
      <v-pagination
        v-model="currentPage"
        :length="totalPages"
        :total-visible="6"
        :disabled="isFetchingConsumptionPage"
        @input="getPage"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import TallyService from '@/services/TallyService.js'

export default {
  name: 'TallyConsumptionTable',
  components: {},
  props: {
    bookingId: Number,
    isLoading: Boolean,
    isDisplayed: Boolean
  },
  data: () => ({
    isFetchingConsumptionPage: false,
    pageItems: [],
    totalPages: 1,
    currentPage: 1,
    skeletonRows: 2,
    requestId: 0,
    error: false
  }),
  computed: {},
  methods: {
    async getPage (page) {
      const requestId = ++this.requestId
      const bookingId = this.bookingId
      this.currentPage = page
      this.isFetchingConsumptionPage = true
      this.pageItems = []
      this.error = false
      try {
        const { data } = await TallyService.getConsumptionPage({ bookingId, page })
        if (requestId !== this.requestId || bookingId !== this.bookingId) { return }
        if (data.status === 'success') {
          this.pageItems = data.data.consumption
          this.skeletonRows = Math.max(this.pageItems.length, 2)
          this.currentPage = parseInt(data.data.current_page, 10)
          this.totalPages = parseInt(data.data.total_pages, 10)
        } else {
          this.error = true
        }
      } catch {
        if (requestId === this.requestId) { this.error = true }
      } finally {
        if (requestId === this.requestId) { this.isFetchingConsumptionPage = false }
      }
    },
    formatDateTime: function (dt) {
      return window.dayjs.parseServerDateTime(dt).toHumanReadableDate()
    }
  },
  watch: {
    bookingId: function () {
      this.requestId++
      this.pageItems = []
      this.currentPage = 1
      this.skeletonRows = 2
      this.totalPages = 1
      this.error = false
      this.isFetchingConsumptionPage = false
      if (this.bookingId && this.isDisplayed) { this.getPage(1) }
    },
    isDisplayed: function () {
      if (this.bookingId && this.isDisplayed) {
        this.totalPages = 1
        this.getPage(1)
      }
    }
  },
  mounted () {
    if (this.bookingId && this.isDisplayed) { this.getPage(1) }
  }
}
</script>
